import { createUserInfoSource } from '@forest/paywall-core'
import { native, type UserInfo } from '@forest/native-services'

export const userInfoSource = createUserInfoSource({
  load: async () => {
    if (import.meta.env.DEV) {
      return {
        server: 'staging',
        token: 'test_token',
        user_id: 1,
        user_type: 'legacy',
      } satisfies UserInfo
    }
    const result = await native.user.getUserInfo()
    if (!result.success || !result.data) {
      throw new Error('Failed to get user info')
    }
    return result.data
  },
  refresh: async () => {
    const result = await native.user.refreshToken()
    if (!result.success) throw new Error('Failed to refresh token')
    return result.data
  },
})

export const $userInfo = userInfoSource.atom
